import { useCallback, useState } from 'react';

import axios from 'axios';
import { notify } from '@periodica/ui-kit';
import { subscribe } from '../periodicaApi/emailSubscribe';

const useEmailSubscriptionFormState = ({
  onSubmit,
  options = {},
}: {
  onSubmit?: () => void;
  options: Record<string, any>;
}) => {
  const [agreePolicy, setAgreePolicy] = useState(false);
  const [email, setEmail] = useState('');
  const [emailErrorMessage, setEmailErrorMessage] = useState<string | undefined>();
  const [agreePolicyError, setAgryPolicyError] = useState<string | undefined>();

  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'submitted'>('idle');

  const handleTextChange = useCallback((newText: string) => {
    setEmail(newText);

    if (newText !== '') {
      setEmailErrorMessage(undefined);
      setAgryPolicyError(undefined);
      setFormStatus('idle');
    }
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const regEx = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (email === '') {
      setEmailErrorMessage('Введите E-mail в формате name@domain.com');
      return;
    }

    if (email !== '' && regEx.test(email) && !agreePolicy) {
      setAgryPolicyError('Необходимо согласиться с правилами, чтобы продолжить');
      return;
    }

    if (!regEx.test(email)) {
      setEmailErrorMessage('Введите E-mail в формате name@domain.com');
      setFormStatus('idle');
      return;
    }
    setEmailErrorMessage(undefined);
    setFormStatus('idle');

    if (email !== '') {
      setFormStatus('submitting');
      try {
        await subscribe(email, options);

        if (onSubmit) {
          onSubmit();
        }

        setFormStatus('submitted');
        setEmail('');

        try {
          window.localStorage.setItem('emailPopup_isSubscribed', 'true');
        } catch {
          // Ignore errors related to localStorage
        }
      } catch (error) {
        setFormStatus('idle');

        if (axios.isAxiosError(error)) {
          if (error.response?.data?.error === 'Throttled') {
            notify({ text: 'Попробуйте позже', type: 'error' });
            return;
          }

          if (
            error.response?.data?.message &&
            typeof error.response?.data?.message === 'string' &&
            error.response?.data?.message.includes('email not valid')
          ) {
            setEmailErrorMessage('Некорректный E-mail');
            return;
          }
        }

        notify({ text: 'Произошла ошибка', type: 'error' });
      }
    }
  };

  return {
    email,
    emailError: emailErrorMessage,
    setEmail: handleTextChange,
    setAgreePolicy,
    agreePolicy,
    agreePolicyError,
    submit: handleSubmit,
    formStatus,
  };
};

export { useEmailSubscriptionFormState };
